module.exports = __webpack_public_path__ + "931c4843d0042a273b571fee1524ded3.png";